"use client";
import dayjs from "dayjs";
import React, { useState } from "react";
import { cn } from "utils";
import { OspToast } from "@ospweb/sdk-ui";
import { ChatCategoryCardType } from "../../Cards/type";
import Translations from "@translate/components/Chat/Charts/token/ComparisonToken";
import { I18nUtil } from "@utils";
import { CheckBoxGroup } from "@/src/components/CheckBoxGroup";

const I18n = I18nUtil.createScoped(Translations);

interface ComparisonTokenProps {
  className?: string;
  cardItem: ChatCategoryCardType;
  createdAt?: string;
  onSelectedValues?: (values: string[]) => void;
}

// 超过30天的记录无法切换比较对象
const DiffDays = 30;

const ComparisonToken: React.FC<ComparisonTokenProps> = ({
  className,
  cardItem,
  createdAt,
  onSelectedValues,
}) => {
  const tokenSymbol = cardItem.properties.token_symbol;

  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  const options = [
    { label: "ETH", value: "ETH" },
    { label: "SOL", value: "SOL" },
  ].filter((item) => item.value !== tokenSymbol);

  const handleChange = (_changedValue: string, newValue: string[]) => {
    setSelectedValues(newValue);
    onSelectedValues?.(newValue);
  };

  const validateSelectionChange = () => {
    // 根据创建时间和当前时间做判断，当创建时间超过一个月，则不能切换
    if (!createdAt) {
      return true; // 如果没有创建时间，则默认允许切换
    }

    // 使用dayjs计算时间差值，简洁高效
    const now = dayjs();
    const createdAtDate = dayjs(createdAt);
    const diffDays = now.diff(createdAtDate, "day"); // 直接使用dayjs的diff方法计算天数差异

    // 如果创建时间超过30天，则不允许切换
    const isValid = diffDays <= DiffDays;

    // 当不符合条件时，显示Toast提示
    if (!isValid) {
      OspToast.error({
        content: I18n.t("No historical data"),
      });
    }

    return isValid; // 返回验证结果
  };

  return (
    <div className={cn("", className)}>
      <div className="flex flex-row items-center gap-4">
        <span className="body_medium_s text-content_tertiary">
          {I18n.t("Comparison:")}
        </span>
        <CheckBoxGroup
          options={options}
          value={selectedValues}
          onChange={handleChange}
          validateSelectionChange={validateSelectionChange}
        />
      </div>
    </div>
  );
};

export default ComparisonToken;
